import { Product } from '../../../types/add-to-cart';
import { Dimensions } from '../../../types/recommendation';

export const productsDataFmt = (products: Product[]) =>
  products.map((product: Product) => {
    const dimensions = {
      dimension13: product?.sellerType,
      dimension14: product?.sellerName,
      dimension55: product?.sellerId,
      dimension119: product?.sku,
    } as Dimensions;

    if (product?.isFromBuyTogether) {
      dimensions.dimension84 = 'Compre Junto';
    }

    if (product?.hasProggresiveDiscount) {
      dimensions.dimension116 = 'desconto-progressivo-pdp';
    }

    return {
      id: product?.id,
      name: product?.name,
      price: product?.price ?? product?.salesPrice,
      quantity: product?.quantity ?? 1,
      category: product?.category,
      ...dimensions,
    };
  });
